'use strict';
var angular = require('angular');
var GeneralInfoController = /** @class */ (function () {
    /*@ngInject*/
    function GeneralInfoController(Auth, $state, $cookies, $scope, UserService, GeneralInfoService, $window) {
        this.audience = 'none';
        this.titles = ['Dr.', 'Miss', 'Mr.', 'Ms.', 'Mrs.'];
        this.professionalDesignations = ['MD', 'DC', 'LMT'];
        this.suffixes = ['II', 'III', 'IV', 'V', 'VI', 'Jr.', 'Sr.', 'Esq.'];
        this.defaultCountry = 'US';
        this.searchText = null;
        this.enteredRegion = null;
        this.cpid = null;
        this.postalCodePattern = "";
        this.phonePattern = new RegExp('^(\\d{3})([\\s-./]?)(\\d{3})([\\s-./]?)(\\d{4})$');
        this.maxPhoneLength = 12;
        this.phonePlaceholder = 'xxx-xxx-xxxx';
        this.billingAddress = {};
        this.audience = UserService.getAudience();
        this.generalInfo = GeneralInfoService;
        this.scope = $scope;
        this.$cookies = $cookies;
        this.$window = $window;
        var self = this;
        if (self.mode == 'new') {
            self.createForm = true;
            self.updateForm = false;
            self.user = {};
            self.user.country = {
                countryCode: 'US',
                countryName: 'United States of America',
                postalCodeRegex: '^\\d{5}(?:[-\\s]\\d{4})?$',
                regionCodeRequired: true
            };
            self.postalCodePattern = new RegExp(self.user.country.postalCodeRegex);
            self.phonePattern = new RegExp('^([2-9]{1})(\\d{2})([\\s-./]?)(\\d{3})([\\s-./]?)(\\d{4})$');
            self.maxPhoneLength = 12;
            self.phonePlaceholder = 'xxx-xxx-xxxx';
        }
        else {
            self.createForm = false;
            self.updateForm = true;
            if (self.user) {
                self.postalCodePattern = new RegExp(self.user.country.postalCodeRegex);
                if (self.user.country.countryCode == 'US') {
                    //self.phonePattern = new RegExp('^\\d{10}$');
                    self.phonePattern = new RegExp('^([2-9]{1})(\\d{2})([\\s-./]?)(\\d{3})([\\s-./]?)(\\d{4})$');
                    self.maxPhoneLength = 12;
                    self.phonePlaceholder = 'xxx-xxx-xxxx';
                }
                else {
                    self.phonePattern = new RegExp('^(\\d)(?!\\1+$)\\d{9,13}$');
                    self.maxPhoneLength = 14;
                    self.phonePlaceholder = '';
                }
            }
        }
        // Listening to the event from submit button in parent (container) template
        $scope.$on('submitForm', function (event, data) {
            self.onUpdate({
                $event: {
                    user: self.user
                }
            });
        });
        $scope.$watch('$viewContentLoaded', function (event) {
            $scope.$watch('gi.accountForm.$valid', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    $scope.$emit('accountFormValid', newVal);
                }
            });
        });
        $scope.$on('countryUpdated', function (event, data) {
            if (data.countryCode == 'US') {
                self.phonePattern = new RegExp('^([2-9]{1})(\\d{2})([\\s-./]?)(\\d{3})([\\s-./]?)(\\d{4})$');
                self.maxPhoneLength = 12;
                self.phonePlaceholder = 'xxx-xxx-xxxx';
            }
            else {
                self.phonePattern = new RegExp('^(\\d)(?!\\1+$)\\d{9,13}$');
                self.maxPhoneLength = 14;
                self.phonePlaceholder = '';
            }
        });
    }
    GeneralInfoController.prototype.navigateToLogin = function () {
        this.$window.location = '/auth/ares';
    };
    // This is to ensure that any changes to our local user object don't reflect in
    // the parent object that was passed to us.
    GeneralInfoController.prototype.$onChanges = function (changes) {
        console.log('In general-info onChange->', changes);
        if (changes.user) {
            this.user = angular.copy(this.user);
        }
        if (changes.audience) {
            this.user = {};
            if (this.accountForm) {
                this.accountForm.$setPristine();
                this.accountForm.$setUntouched();
                this.accountForm.email.$error = {};
                this.accountForm.firstName.$error = {};
                this.accountForm.lastName.$error = {};
                this.accountForm.phone.$error = {};
            }
        }
    };
    GeneralInfoController.prototype.checkEmail = function () {
        var self = this;
        if (this.user.email && this.user.email !== '') {
            this.generalInfo.checkEmailAccountExists(encodeURIComponent(this.user.email)).then(function (accountExist) {
                if (accountExist) {
                    self.accountForm.email.$error.accountExistsError = true;
                    self.accountForm.$setValidity('accountExists', false);
                    self.fireEvent('emailError');
                }
                else {
                    self.accountForm.email.$error.accountExistsError = false;
                    self.accountForm.$setValidity('accountExists', true);
                }
            });
        }
        this.validateFormAndFireError('email', 'emailError', ['accountExistsError']);
    };
    GeneralInfoController.prototype.verifyPassword = function () {
        var self = this;
        if (self.user.password != self.user.verifyPassword) {
            self.accountForm.verifyPassword.$setValidity('passwordMatchError', false);
        }
        else {
            self.accountForm.verifyPassword.$setValidity('passwordMatchError', true);
        }
    };
    GeneralInfoController.prototype.createPassword = function () {
        var self = this;
        if (self.user.verifyPassword && (self.user.password != self.user.verifyPassword)) {
            self.accountForm.verifyPassword.$setValidity('passwordMatchError', false);
        }
        else {
            self.accountForm.verifyPassword.$setValidity('passwordMatchError', true);
        }
    };
    GeneralInfoController.prototype.removeSeperatorsFromPhoneNum = function () {
        if (this.user.phone) {
            this.user.phone = this.user.phone.replace(/[\s-.\/]/g, "");
            console.log('Phone num -> ', this.user.phone);
        }
    };
    GeneralInfoController.prototype.getLandingPageName = function (cpid) {
        var self = this;
        this.generalInfo.getLandingPageName(cpid).then(function (response) {
            if (response.status == 200 && response.data.response) {
                self.user.additionalDetails = response.data.response;
            }
        });
    };
    GeneralInfoController.prototype.disallowWhiteSpace = function (event) {
        if (event.which === 32) {
            event.preventDefault();
        }
    };
    GeneralInfoController.prototype.$onInit = function () {
        var self = this;
        console.log('In general-info onInit');
        self.cpid = this.$cookies.get('cpid');
        if (self.cpid) {
            self.getLandingPageName(self.cpid);
        }
    };
    GeneralInfoController.prototype.$onDestroy = function () {
        console.log('In general-info onDestroy');
    };
    GeneralInfoController.prototype.$postLink = function () {
        console.log('In general-info postLink');
    };
    GeneralInfoController.prototype.fireEvent = function (eventName) {
        this.scope.$emit('generalInfoTrackingEvent', { eventName: eventName });
    };
    GeneralInfoController.prototype.validateFormAndFireError = function (fieldName, errorName, exceptionProperties) {
        if (exceptionProperties === void 0) { exceptionProperties = []; }
        var field = this.accountForm[fieldName];
        if (!field)
            return;
        for (var error in field.$error) {
            if (exceptionProperties.indexOf(error) === -1 && field.$error.hasOwnProperty(error) && field.$error[error]) {
                this.fireEvent(errorName);
                return;
            }
        }
    };
    return GeneralInfoController;
}());
export default GeneralInfoController;
//# sourceMappingURL=general-info.controller.js.map